export const PedestrismoBackup = 5;
export const Pedestrismo = 1;
export const RuralBike = 4;
export const CombinadaSprint = 2;
export const CombinadaSimple = 3;

export const Parcial1Field = 'formattedTime1';
export const Parcial2Field = 'formattedTime2';
export const Parcial3Field = 'formattedTime3';

export let competitionList = {
	1: 'Pedestrismo',
	2: 'Prueba Combinada Tiempo Parcial',
	3: 'Prueba Combinada Tiempo Unico',
	4: 'Rural Bike'
}

export let genderList = {
		 'M': 'M',
		 'F': 'F'	 
	};

export let distanceList = {
	1: '1K',
	2: '2K',
	3: '3K',
	4: '4K',
	5: '5K',
	6: '6K',
	7: '7K',
	8: '8K',
	9: '9K',
	10: '10K',
	11: '11K',
	12: '12K',
	13: '13K',
	14: '14K',
	15: '15K',
	16: '16K',
	17: '17K',
	18: '18K',
	19: '19K',
	20: '20K',
	21: '21K',
}



// WEBPACK FOOTER //
// ./src/constants/enums.js